import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { selectToken } from '../../util/tokenSelector.js';
import { useDirectionContext, Direction } from '../../contexts/session/Locale.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { GroupStyled } from './Group.styled.js';
import { GroupContext } from './GroupContext.js';

var _excluded = ["children", "childrenRemoveBorderRadius"];

/**
 * Group component is used to group elements together.
 */
var Group = function Group(_ref) {
  var children = _ref.children,
    childrenRemoveBorderRadius = _ref.childrenRemoveBorderRadius,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  var theme = useThemeContext();
  var radius = childrenRemoveBorderRadius ? '0px' : selectToken(theme.radius, '4');
  return /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: true
  }, /*#__PURE__*/React.createElement(GroupStyled, _extends({
    role: "group"
  }, rest, {
    $isRTL: direction === Direction.RTL,
    $radius: radius
  }), children));
};
var GroupMemoized = /*#__PURE__*/React.memo(Group);
GroupMemoized.displayName = 'Group';

export { Group as BaseGroup, GroupMemoized as Group };
//# sourceMappingURL=Group.js.map
